module.exports = __webpack_public_path__ + "img/sell.ee5a958d.png";